import React from 'react'
import TotalScore from './TotalScore'
import NumberSelector from './NumberSelector'
import styled from 'styled-components'
import RoleDice from './RoleDice'
import { useState } from 'react'
import { Button, OutlineButton } from './Styled/Button'
import Rules from './Rules'

const GamePlay = () =>{
  const [score, setScore] = useState(0);
  const [selectedNumber, setSelectedNumber] = useState();
  const [currentDice, setCurrentDice] = useState(1);
  const [error, setError]= useState("");
  const [showRules, setShowRules] = useState(false);

  const generateRandumNumber = (min, max) => {
    return Math.floor( Math.random() * (max - min) + min);
  }

  const roleDice =() => {
    if (!selectedNumber) {
        setError("You have not selected any number");
      return;
    }
    
    const randomNumber = generateRandumNumber(1,7);
    setCurrentDice((prev) => randomNumber);

    if(selectedNumber === randomNumber) {
      setScore((prev) => prev + randomNumber);
    }else{
      setScore((prev) =>prev - 2)
    }

    setSelectedNumber(undefined);
  }

  const resetScore = () =>{
    setScore(0)
  }


  return (
    <TopSection>
        <div className='top_section'>
        <TotalScore score={score}/>
      <NumberSelector
      error={error}
      setError={setError}
      selectedNumber={selectedNumber} 
      setSelectedNumber={setSelectedNumber}/>
        </div> 
        <RoleDice
        currentDice={currentDice} roleDice={roleDice} />
        <div className='btnn'>
          <OutlineButton onClick={resetScore}>Reset Score</OutlineButton>
          <Button onClick={()=> setShowRules((prev) =>!prev)}>{showRules? "Hide":"Show"} Rules</Button>
          {showRules && <Rules/>}
        </div>
    </TopSection>
  )
}

export default GamePlay

const TopSection = styled.main`
padding-top: 60px;
    .top_section{
        display: flex;
        justify-content: space-around;
        align-items: end;
    }
    .btnn{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
`
